import { useScrmFetch } from "@/hooks/common/fetch/useFetch";
import { useFirstUpperCase, useBrand } from "@/hooks/common/useUtils";

let brand = useBrand();
brand = ["kd"].indexOf(brand) === -1 ? useFirstUpperCase(brand) : brand.toUpperCase();
const country = document.body.dataset.originalSite?.toLocaleUpperCase();
const { language } = document.body.dataset;

export const useSendVerificationCode = async (emailAddress) => {
  return await useScrmFetch(`/web/iscrm-edm/api/datasource/sendVerificationCode`).post({
    emailAddress,
    brand,
    language,
  }).json();
}

// HK campaign
export const useHKCampaignSaveApi = async (params = {}) => {
  return await useScrmFetch(`/web/iscrm-edm/api/datasource/saveDataSource`).post({
    ...params,
    brand,
    country,
    touchPoint: 'Websites',
    entrance: 'APAC',
    languageCategory: language,
  }).json();
}

// customized
export const useCustomizedSaveApi = async (params = {}) => {
  return await useScrmFetch(`/web/iscrm-edm/api/datasource/saveDataSourceV2`).post({
    ...params,
    brand,
    country,
    touchPoint: 'Websites',
    entrance: 'APAC',
    languageCategory: language,
  }).json();
}


